import "./CardMapDoctor.scss";
import { useRef, useState } from "react";
import { GeneralPractitionerResponse } from "@anoki/fse-common/dist/types/general-practitioner-service";
import * as CheckboxRadix from "@radix-ui/react-checkbox";
import { useClickOutside } from "@/hooks/useClickOutside.ts";
import { ArrowLink, Col, Row } from "@/components";
import { CheckIcon } from "@/icons";
import { HeadingLevel } from "@/types/headings";

type CardMapDoctorProps = {
  titleTag: HeadingLevel;
  availableLabel: string;
  specialization?: string;
  addressLabel?: string;
  className?: string;
  doctor: GeneralPractitionerResponse;
  setSelectedCard?: (id: string) => void;
  keepSelectionOnNavigation?: boolean;
  ctaTitle?: string;
  ctaAction?: () => void;
};

export const CardMapDoctor = ({
  titleTag: TitleTag = "h1",
  availableLabel = "Disponibile",
  specialization,
  addressLabel,
  className,
  doctor,
  setSelectedCard = () => {},
  keepSelectionOnNavigation = false,
  ctaTitle,
  ctaAction,
}: CardMapDoctorProps) => {
  const [isActive, setIsActive] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const address = doctor?.offices[0];
  useClickOutside(
    dropdownRef,
    isActive,
    () => setIsActive(false),
    () => setSelectedCard(""),
    keepSelectionOnNavigation,
  );

  return (
    <Row
      br={"x4"}
      p={"x24"}
      gap={"x16"}
      bg={"white"}
      text={"slate-20"}
      ref={dropdownRef}
      className={`${className} ${isActive ? "ui-is-active ui-card-search" : "ui-card-search"} shadow cursor-pointer`}
      onClick={() => {
        setIsActive(true);
        setSelectedCard(doctor?.code);
      }}
    >
      <CheckboxRadix.Root
        id={doctor?.code}
        checked={isActive}
        // onCheckedChange={onChange}
        className={"ui-checkbox-filter"}
        // aria-label={labelText}
      >
        <CheckboxRadix.Indicator>
          <CheckIcon width={14} height={14} color="white" />
        </CheckboxRadix.Indicator>
      </CheckboxRadix.Root>
      <Col justifyContent={"center"} className={`w-full`}>
        <Col pb={"x16"}>
          <TitleTag className="flex-1 text-decoration-none fs-4 fw-semibold">
            Dott. {doctor?.firstName} {doctor?.lastName}
          </TitleTag>
          {!!specialization && (
            <p className="fs-6 fw-regular text-slate-28">{specialization}</p>
          )}
          <div
            className={
              "ui-available-label mt-x4 px-x16 py-x4 bg-status-success text-white rounded fw-semibold fs-7"
            }
          >
            {availableLabel.toUpperCase()}
          </div>
        </Col>
        <Row justifyContent={"space-between"} alignItems={"end"}>
          <div className={"text-slate-28 fs-6"}>
            <div className={"fw-bold"}>{addressLabel}</div>
            <div className={"w-full"}>
              <p className={"fw-regular"}>
                {address?.address
                  ? address.address.charAt(0).toUpperCase() +
                    address.address.slice(1).toLowerCase()
                  : ""}
                ,{" "}
                {address?.city
                  ? address.city.charAt(0).toUpperCase() +
                    address.city.slice(1).toLowerCase()
                  : ""}
              </p>
            </div>
          </div>
          {ctaTitle && ctaAction && (
            <ArrowLink
              asButton
              onClick={ctaAction}
              arrowVisible={false}
              className={"cursor-pointer"}
            >
              {ctaTitle}
            </ArrowLink>
          )}
        </Row>
      </Col>
    </Row>
  );
};
